<div class="mb-6 md:mb-0 flex flex-row items-center gap-2">
  <a class="flex title-font font-medium items-center md:justify-start justify-center text-gray-900"
  target="_self"   href="www.softnetcomputers.lk" aria-label="website link">
    <img class="h-10 w-16 object-contain" loading="lazy" alt="softnet computers logo"
      src="../../../../assets/branding/softnet-logo.webp">
    <span class="ml-3 text-xl text-white">Computers

    </span>

    <!-- <a href="https://fb.com/softnetcomputers.lk" [ariaLabel]="'facebook account'" class="text-gray-600 ml-1 pt-1"
    rel="noopener noreferrer" target="_blank">fb.com/softnetcomputers.lk</a> -->
  </a>

</div>



<div class="grid grid-cols-1  md:grid-cols-3">
  <div>



    <h2 class="mb-2 mt-4 text-sm font-semibold text-white uppercase  ">find us:</h2>

    <p class="leading-relaxed text-[#90908f]">No.537/D, Chilaw Road,<br> Dalupotha, Negombo</p>
  </div>

  <div class="flex flex-col">
    <h2 class="mb-2 mt-4 text-sm font-semibold text-white uppercase  ">call us:</h2>

    <a  target="_blank" href="tel:+9477 255 3478" [ariaLabel]="'phone number 1'" class="text-blue-700"> <u> 077 255 3478</u></a>
    <a  target="_blank" href="tel:+9477 390 4170" [ariaLabel]="'phone number 2'" class="text-blue-700"> <u> 077 390 4170 </u></a>
    <a target="_blank" href="tel:+9431 223 5988      " [ariaLabel]="'phone number 3'" class="text-blue-700"> <u> 031 223 5988
      </u></a>



  </div>

  <div>



    <h2 class="mb-2 mt-4 text-sm font-semibold text-white uppercase  ">email us at:</h2>
    <a href="mailto:softnetplc@gmail.com " [ariaLabel]="'email'" class="text-blue-700"> <u>
        {{"softnetplc@gmail.com"}}

      </u></a>
  </div>


  <div  class="flex flex-row pt-4 md:col-span-3">
    <a aria-label="tik tok account"  target="_blank" href="https://www.tiktok.com/@softnetcomputers?_t=8lI15zNGKe0&_r=1"
      class="text-gray-500 px-2">

      <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5"
        viewBox="0 0 24 24">
        <path
          d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.104,4,24,4z M22.689,13.474 c-0.13,0.012-0.261,0.02-0.393,0.02c-1.495,0-2.809-0.768-3.574-1.931c0,3.049,0,6.519,0,6.577c0,2.685-2.177,4.861-4.861,4.861 C11.177,23,9,20.823,9,18.139c0-2.685,2.177-4.861,4.861-4.861c0.102,0,0.201,0.009,0.3,0.015v2.396c-0.1-0.012-0.197-0.03-0.3-0.03 c-1.37,0-2.481,1.111-2.481,2.481s1.11,2.481,2.481,2.481c1.371,0,2.581-1.08,2.581-2.45c0-0.055,0.024-11.17,0.024-11.17h2.289 c0.215,2.047,1.868,3.663,3.934,3.811V13.474z" />
      </svg>
    </a>

    <a href="https://fb.com/softnetcomputers.lk" target="_blank" aria-label="facebook account" class="text-gray-500">
      <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5"
        viewBox="0 0 24 24">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
      </svg>
    </a>

    <a href="https://www.instagram.com/softnet_technics" target="_blank" aria-label="insta account"
      class="ml-3 text-gray-500">
      <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        class="w-5 h-5" viewBox="0 0 24 24">
        <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
        <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
      </svg>
    </a>

    <a class="ml-3 text-gray-500" href="https://api.whatsapp.com/send/?phone=%2B94772553478&text&app_absent=0" target="_blank"
      aria-label="whatsapp account">

      <svg fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"
        class="w-5 h-5" viewBox="0 0 24 24">
        <path
          d="m12 1.9673c-5.5406 0-10.033 4.4922-10.033 10.033 0 1.8821 0.52868 3.6369 1.4304 5.1421l-1.3406 4.8906 4.9951-1.3112c1.4609 0.83056 3.1473 1.3112 4.9478 1.3112 5.5406 0 10.033-4.4922 10.033-10.033 0-5.5406-4.4922-10.033-10.033-10.033zm-3.4341 5.3527c0.16303 0 0.33054-9.954e-4 0.47518 0.00658 0.17892 0.00424 0.37365 0.017279 0.56009 0.42946 0.22156 0.48993 0.70398 1.719 0.76584 1.8436 0.06187 0.12457 0.10571 0.27133 0.01959 0.43436-0.08193 0.16721-0.12455 0.26841-0.24494 0.4164-0.12457 0.1438-0.26107 0.3224-0.37394 0.43109-0.12457 0.12457-0.25321 0.26116-0.1094 0.50948 0.1438 0.24831 0.64322 1.0623 1.3815 1.7195 0.94893 0.84777 1.7496 1.1083 1.9987 1.2329 0.24915 0.12457 0.39343 0.10517 0.53724-0.06206 0.14798-0.16303 0.62149-0.72245 0.7887-0.9716 0.16303-0.24914 0.32946-0.20604 0.5552-0.1241 0.22908 0.08193 1.4507 0.68373 1.6999 0.8083 0.24915 0.12457 0.41248 0.18623 0.47518 0.2874 0.06438 0.1045 0.06444 0.60202-0.14207 1.1822-0.20651 0.57939-1.2206 1.1397-1.6754 1.179-0.459 0.04264-0.88736 0.20631-2.9834-0.61888-2.5282-0.99575-4.1227-3.5853-4.2472-3.7525-0.12457-0.16303-1.0124-1.3463-1.0124-2.567 0-1.2248 0.64219-1.8247 0.86709-2.0738 0.22908-0.24915 0.49739-0.31026 0.6646-0.31026z"
          stroke-width=".83606" />
      </svg>


    </a>
  </div>
</div>